import { Heart, MessageCircle, Share2 } from 'lucide-react'
import { useState } from 'react'

const MainPost = ({ post }) => {
    const [isLiked, setIsLiked] = useState(post.isLike)
    const [likesCount, setLikesCount] = useState(post.totalLikes || post.totalLike)

    const handleLike = () => {
        setIsLiked(!isLiked)
        setLikesCount(prev => isLiked ? prev - 1 : prev + 1)
    }

    return (
        <article className="bg-white rounded-2xl shadow-lg overflow-hidden border border-gray-100">
            <h1 className="text-xl md:text-3xl font-bold px-6 pt-6 text-gray-900 leading-tight">
                {post.title}
            </h1>

            {post.imgUrl && (
                <div className="px-6 py-4">
                    <div className="relative rounded-xl overflow-hidden">
                        {post?.postMediaType === 'video' ? (
                            <video
                                controls
                                poster={post?.thumbImgUrl || "https://upload.wikimedia.org/wikipedia/commons/d/d1/Image_not_available.png"}
                                className="w-full h-96 object-contain"
                                src={post?.imgUrl || "https://upload.wikimedia.org/wikipedia/commons/d/d1/Image_not_available.png"}
                                onContextMenu={(e) => e.preventDefault()} // Disables right-click menu
                                disablePictureInPicture
                                controlsList="nodownload noplaybackrate"
                            >
                                Your browser does not support the video tag.
                            </video>
                        ) : (
                            <img
                                src={post.imgUrl || 'https://upload.wikimedia.org/wikipedia/commons/d/d1/Image_not_available.png'}
                                alt={post.title}
                                className="w-full h-96 object-contain bg-gray-50"
                            />)
                        }
                    </div>
                </div>
            )}

            <div className="px-6 pb-4">
                <p className="text-lg leading-relaxed text-gray-700">
                    {post.desc}
                </p>
            </div>

            <div className="border-t border-gray-100 px-6 py-4">
                <div className="flex items-center justify-between">
                    <div className="flex items-center gap-6">
                        <button
                            // onClick={handleLike}
                            className={`flex items-center gap-2 transition-colors ${isLiked ? 'text-red-600' : 'text-gray-600 hover:text-red-600'
                                }`}
                        >
                            <Heart className={`w-5 h-5 ${isLiked ? 'fill-current' : ''}`} />
                            <span className="text-sm font-medium">{likesCount} Likes</span>
                        </button>
                        <div className="flex items-center gap-2 text-gray-600">
                            <MessageCircle className="w-5 h-5" />
                            <span className="text-sm font-medium">{Math.abs(post.totalComment)} Comments</span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="flex items-center gap-3 px-6 pb-6 border-t border-gray-100 pt-4">
                <img
                    src={post.user?.profileImage || `https://ui-avatars.com/api/?name=${post.user?.fullName}&background=random`}
                    alt={post.user?.fullName}
                    className="w-10 h-10 rounded-full"
                />
                <div>
                    <p className="text-sm font-semibold text-gray-900">{post.user?.fullName}</p>
                    <p className="text-xs text-gray-500">
                        {post.user?.isExpert && '⭐ Expert • '}
                        {post.user?.followers} followers
                    </p>
                </div>
            </div>
        </article>
    )
}

export default MainPost;